import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import PlaceDetail from "@/pages/PlaceDetail";
import EventDetail from "@/pages/EventDetail";
import Events from "@/pages/Events";
import Itinerary from "@/pages/Itinerary";
import Saved from "@/pages/Saved";
import Auth from "@/pages/Auth";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import SharedItinerary from "@/pages/SharedItinerary";
import Sponsor from "@/pages/Sponsor";
import Submit from "@/pages/Submit";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Trail from "@/pages/Trail";
import Trails from "@/pages/Trails";
import JoinAdmin from "@/pages/JoinAdmin";
import Videos from "@/pages/Videos";
import SponsorDashboard from "@/pages/SponsorDashboard";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/place/:slug" element={<PlaceDetail />} />
          <Route path="/event/:id" element={<EventDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/itinerary" element={<Itinerary />} />
          <Route path="/trails" element={<Trails />} />
          <Route path="/trail/:slug" element={<Trail />} />
          <Route path="/i/:shareId" element={<SharedItinerary />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/join-admin" element={<JoinAdmin />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/sponsor" element={<Sponsor />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/my-listings" element={<SponsorDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
